class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.clicks = 0;
    this.secondClickOnQuickAdd = false;
  }

  connectedCallback() {
    this.loadContent();
    this.displayModal();
    this.closeOnQuickAdd();
  }

  loadContent() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.upsell-popup');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.closeModal();
        this.initCarousel();
      })
      .catch(e => {
        console.error(e);
      });
  }

  closeModal() {
    const closeButton = this.querySelector('.upsell-popup__closebtn');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.hideModal();
      });
    }
  }

  displayModal() {
    const PdpaddToCartButton = document.querySelector('[data-add-to-cart]');

    if (PdpaddToCartButton) {
      PdpaddToCartButton.addEventListener('click', () => {
        const popupWrapper = this.closest('.upsell-popup-wrapper');
        if (popupWrapper && this.clicks === 0) {

          this.observeCartDrawer();
          popupWrapper.classList.add('upsell-popup-active');
          document.body.classList.add('upsell-popup-active');
        }
        this.clicks += 1;
      });
    }
  }

  observeCartDrawer() {
    const observerOptions = {
      childList: true,
      subtree: true
    };

    this.observer = new MutationObserver((mutations) => {
      const cartDrawer = document.getElementById('CartDrawer');
      
      if (cartDrawer) {
        const cartDrawerPosition = cartDrawer.getBoundingClientRect();
        const cartDrawerXaxisPosition = cartDrawerPosition.x;
        console.log('Cart Drawer Position:', cartDrawerXaxisPosition);
        if (cartDrawerXaxisPosition > 0) {          
          const cartDrawerBtnClose = document.querySelector('.drawer__close-button');
          cartDrawerBtnClose.click();
          this.observer.disconnect();
        }
      }
    });

    this.observer.observe(document.body, observerOptions);
  }
  
  initCarousel() {
    const carousel = this.querySelector('.shopify-upsell-popup-carousel');

    if (carousel) {
      $(carousel).slick({
        arrows: false,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        variableWidth: true,
        touchMove: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1090,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      const carouselButton = this.querySelector('[data-upsell-popup-carousel-button="next"]');

      if (carouselButton) {
        carouselButton.addEventListener('click', () => {
          $(carousel).slick('slickNext');
        });
      }

      $(document).on(
        'click',
        '.shopify-upsell-popup-carousel .product-card-refresh .product-card--variants .close',
        (e) => {
          const $container = $(e.currentTarget).closest('.product-card--variants');
          $container.removeClass('active');
          $container
            .closest('.product-card-refresh')
            .find('.product-card--button button')
            .removeAttr('data-ready-to-add')
            .text('Quick add');
        }
      );

      const setHeights = () => {
        let maxHeight = 0;
        const container = this.querySelector('.upsell-popup');
        const messages = container.querySelectorAll('.product-title-review-container');

        messages.forEach(message => {
          message.removeAttribute('style');
          maxHeight = Math.max(maxHeight, message.clientHeight);
        });

        messages.forEach(message => {
          message.style.height = `${maxHeight}px`;
        });

        $(carousel).slick('refresh');
      };

      $(window).on('resize', $.debounce(100, setHeights.bind(this)));

      setHeights();
    }
  }

  hideModal() {
    const popupWrapper = this.closest('.upsell-popup-wrapper');
    if (popupWrapper) {
      popupWrapper.classList.remove('upsell-popup-active');
      document.body.classList.remove('upsell-popup-active');
    }
  }

  closeOnQuickAdd() {
    this.addEventListener('click', (event) => {
      if (event.target.matches('[data-quickshop]')) {
        if (this.secondClickOnQuickAdd) {
          this.hideModal();
          this.secondClickOnQuickAdd = false;
        } else {
          this.secondClickOnQuickAdd = true;
        }
      }
    });
  }
  
}

class PdmCategoryCarouselMobile extends HTMLElement {
  constructor() {
    super();
    this.width = 0;
  }

  connectedCallback() {
    this.getWindowWidth();
    this.calcTopPadding();
    this.setupResizeListener();
    this.initCarousel();
  }

  getWindowWidth() {
    this.width = window.innerWidth; 
    console.log('Initial window width is:', this.width);
  }

  setupResizeListener() {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  onResize() {
    this.width = window.innerWidth;
    console.log('Updated window width is:', this.width);
    this.initCarousel();//
    this.calcTopPadding();
  }

  calcTopPadding() {
    if (this.width <= 366) {
      console.log('Window width meets calcTopPadding criteria');
      
      const categoryCarouselWrapper = document.querySelector('.pdm-category-carousel-mobile-wrapper');
      const announcementBarClose = document.querySelector('.announcement-bar__close');
  
      if (categoryCarouselWrapper && announcementBarClose) {
        categoryCarouselWrapper.classList.add('padding-adjustment');
  
  
        announcementBarClose.removeEventListener('click', this.handleAnnouncementBarClose);
        announcementBarClose.addEventListener('click', this.handleAnnouncementBarClose.bind(this, categoryCarouselWrapper));
      }
    }
  }
  
  handleAnnouncementBarClose(categoryCarouselWrapper) {
    if (categoryCarouselWrapper.classList.contains('padding-adjustment')) {
      categoryCarouselWrapper.classList.remove('padding-adjustment');
      console.log('Padding adjustment removed');
    }
  }

  initCarousel() {
    const carousel = this.querySelector('.pdm-category-carousel-mobile');

    if (carousel) {
      $(carousel).slick({
        arrows: false,
        dots: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        touchMove: true,
        centerMode: false,
        mobileFirst: true,
        swipeToSlide: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 389,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: 'unslick',
          }
        ]
      })
    }
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('upsell-popup', UpsellPopup);
  customElements.define('pdm-category-carousel', PdmCategoryCarouselMobile);
});
  